<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    title-text="Выберите участника для копирования"
    cancel-btn="Отменить"
    success-btn="Копировать"
    @closed="$emit('closed')"
  >
    <BAutocompleteCommon
      v-model="form.participants_list_id"
      :return-object="false"
      $type="participant"
    />

    <template #footer="{ close: c }">
      <v-spacer />

      <v-btn
        text
        type="button"
        @click="c()"
        v-text="'Отменить'"
      />

      <v-btn
        :loading="isLoading"
        depressed
        :disabled="!form.participants_list_id"
        @click="onCopy"
        v-text="'Копировать'"
      />
    </template>
  </BModalConfirm>
</template>

<script>
import { ParticipantsApi } from '@/api/resources'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


export default {
  name: 'PermissionsGroupsCopyAteModal',
  components: {
    BModalConfirm,
    BAutocompleteCommon,
  },
  inheritAttrs: false,
  data: () => ({
    isLoading: false,
    form: {
      participants_list_id: null,
    },
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(flag) {
      return this.$refs.modal.close(flag)
    },
    async onCopy() {
      const api = new ParticipantsApi()
      const id = this.form.participants_list_id
      this.isLoading = true

      try {
        const { data } = await api.getListForCopy(id)

        const form = {
          regions: data.regions,
          municipalities: data.municipalities,
          schools: data.schools,
        }

        this.close(form)
      } catch (e) {
        this.$notice.errors(e)
      }

      this.isLoading = false
    },
  },
}
</script>
